import { getToken } from '../helpers';

export const getAPIurl = () => {
  const clientUrl = window.location.href;
  if (clientUrl.includes('localhost')) {
    return "https://demo-api.valest-app.de/api";
    //return 'http://localhost:1339/api';
  }
  const match = clientUrl.match(/https:\/\/(.*?)\.valest-app/);
  if (match && match[1]) {
    return `https://${match[1]}-api.valest-app.de/api`;
  }
  return '';
};

/**
 * Zentraler Fetch-Wrapper. Hängt Bearer-Token und Content-Type automatisch an.
 * Für Multipart/FormData darf Content-Type NICHT gesetzt werden → options.multipart = true
 */
export const apiFetch = async (path, options = {}) => {
  const { multipart, ...fetchOptions } = options;
  const token = getToken();

  const headers = {
    ...(multipart ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...fetchOptions.headers,
  };

  return fetch(`${getAPIurl()}${path}`, { ...fetchOptions, headers });
};

/**
 * Liest den Response-Body und parst JSON. Bei Fehlerstatus oder nicht-JSON-Body
 * wird eine aussagekräftige Error geworfen (z. B. ACL liefert Klartext "Not allowed...").
 */
export const parseJsonResponse = async (response) => {
  const text = await response.text();
  const trimmed = text.trim();

  // ACL lieferte früher HTTP 200 mit Klartext — ohne diesen Check: JSON.parse-Fehler
  if (response.ok && trimmed.startsWith('Not allowed')) {
    throw new Error(trimmed);
  }

  if (!response.ok) {
    let message = trimmed || `HTTP ${response.status}`;
    try {
      const data = JSON.parse(text);
      message =
        data.error?.message ||
        data.message ||
        data.Error_from_ACL ||
        (typeof data.error === 'string' ? data.error : null) ||
        message;
    } catch {
      /* Body ist Klartext oder kein JSON */
    }
    throw new Error(message);
  }
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(
      `Ungültige Antwort vom Server: ${text.slice(0, 120)}${text.length > 120 ? '…' : ''}`
    );
  }
};

export const apiGet = (path, options = {}) =>
  apiFetch(path, { method: 'GET', ...options });

export const apiPost = (path, body, options = {}) =>
  apiFetch(path, { method: 'POST', body: JSON.stringify(body), ...options });

export const apiPut = (path, body, options = {}) =>
  apiFetch(path, { method: 'PUT', body: JSON.stringify(body), ...options });

export const apiDelete = (path, options = {}) =>
  apiFetch(path, { method: 'DELETE', ...options });

export const isAllowedDomain = () => {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === 'buettner.valest-app.de';
};

export const isDemoDomain = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'demo.valest-app.de';
};
